<template>
  <div>
    <p class="text-l text-bold">{{ detailData.title || detailData.vipName }}</p>
    <p
      class="text-sm1 text-grey"
      v-if="$route.query.name != 'expertList' && $route.query.name != 'style'"
    >
      <span>作者：{{ detailData.author }}</span
      ><span class="margin-left">时间：{{ detailData.updateTime }}</span>
    </p>
    <p class="text-sm1 text-grey">{{ VipTypes[detailData.vipType] }}</p>
    <div
      class="margin-top html-content"
      v-html="detailData.content"
      style="width: 100%"
    ></div>
  </div>
</template>
<script>
import api from "@/utils/api";
export default {
  data() {
    return {
      detailData: {},
      apiList: [
        {
          key: "researchReport", //产业研究报告
          apiName: "getResearchReportDetailApi",
        },
        {
          key: "expertList", //专家智库名录
          apiName: "getResearchReportDetailApi",
        },
        {
          key: "notice", //通知公告
          apiName: "getNoticeDetailApi",
          type: null,
        },
        {
          key: "news", //协会要闻
          apiName: "getNewsDetailApi",
          type: null,
        },
        {
          key: "memberCenter", //会员动态
          apiName: "getVipDetailApi",
          type: null,
        },
        {
          key: "industry", //产业动态
          apiName: "getPropertyDetailApi",
          type: null,
        },
        {
          key: "vipDescribe", //会员风采
          apiName: "getVipDescribeDetailApi", //产业动态
          type: null,
        },
      ],
      VipTypes: {
        1: "轮值理事长单位",
        2: "副理事长单位",
        3: "理事单位",
        4: "会员单位",
      },
    };
  },
  watch: {
    "$route.path": {
      handler() {
        let apiName = this.apiList.filter(
          (e) => e.key == this.$route.query.name
        )[0].apiName;
        this.getData(apiName);
      },
      immediate: true,
    },
  },
  methods: {
    async getData(apiName) {
      let res = await api[apiName](this.$route.query.id);
      if (res.code == 200) {
        this.detailData = res.data;
      }
    },
  },
};
</script>
<style>
.html-content img {
  width: 100%;
}
</style>